import React, { useEffect, useState, useRef } from "react";
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import axiosConn from "config/axiosConn";
// import SpinnerOverlay from "../Components/SchoolAdmin/Spinner";

dayjs.extend(isSameOrAfter);

function AdminViewTabletrees() {
    const location = useLocation();
    const dispatch = useDispatch();
    const userData = useSelector(state => state.auth.user);

    const [eventsData, setEventsData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    // Derived state
    const storedState = (() => {
        const params = new URLSearchParams(location.search);
        let stateParam = params.get('state');

        if (location.pathname.includes('admin') && !location.pathname.includes('admin/state-level')) {
            return '';
        } else if (location.pathname.includes('admin/state-level') && (!stateParam || stateParam === 'null')) {
            return localStorage.getItem('filterDataState');
        }
        return stateParam;
    })();

    const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

    const getStateList = async (data, page = 1) => {
        console.log("getStateList called with data:", data);
        try {
            setLoading(true);
            const response = await axiosConn('post', "ekped-allrecords-page", { ...data, page, limit: 10 }, {}, dispatch);
            if (response.data.status === "success") {
                const records = response.data.records.records || [];
                const filtered = records.filter(item => item._id && item.student_name);
                setEventsData(filtered);
                setTotalPages(response.data.records.totalPages || 1);
                setCurrentPage(response.data.records.currentPage || 1);
            } else {
                setEventsData([]);
            }
        } catch (err) {
            console.error("Fetch error:", err);
            setEventsData([]);
        } finally {
            setLoading(false);
        }
    };

    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
            scrollToTop();
        }
    };

const downloadCSV = async () => {
    try {
        setLoading(true);
        const response = await axiosConn(
            'post',
            "ekped-allrecords-page",
            { state: storedState, page: 1, limit: 100000 },
            {},
            dispatch
        );
        const allData = response?.data?.records?.records || [];

        if (!Array.isArray(allData) || allData.length === 0) {
            alert("No data available to download.");
            return;
        }

        const headers = ["S.no", "UDISE ID", "School Name", "District", "EduBlockName/Ward No."];
        const rows = allData.map((item, index) => [
            index + 1,
            `"${item.school_data?.udiseCode || item.udise_id || 'N/A'}"`,
            `"${item.school_data?.schooName || 'N/A'}"`,
            `"${item.school_data?.eduDistrictName || 'N/A'}"`,
            `"${item.school_data?.eduBlockName || 'N/A'}"`
        ]);

        const csvContent = "\uFEFF" + [headers, ...rows].map(e => e.join(",")).join("\n");
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `school_list_${storedState || 'all'}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    } catch (error) {
        console.error("CSV download error:", error);
        alert("Failed to download CSV.");
    } finally {
        setLoading(false);
    }
};


    useEffect(() => {
        if (userData && storedState !== null) {
            getStateList({ eduStateName: storedState }, currentPage);
        }
    }, [userData, storedState, currentPage]);

    return (
        <div className="content">
            <div className="btmTableDivIn">
                <div className="tableTopDiv">
                    <div className="dwnldexel mb-3">
                        <button className="btn btn-primary" onClick={downloadCSV}>Download CSV</button>
                    </div>
                    <h3 style={{ fontWeight: 'bold', marginBottom: '1rem' }}>
                        Number of Schools Participated
                    </h3>
                    <div className="table-responsive" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                        {!loading ? (
                            <table className="table" rules="all">
                                <thead className="text-primary" style={{
                                    position: 'sticky', top: 0, backgroundColor: '#fff',
                                    zIndex: 1000, boxShadow: '0 2px 2px -1px rgba(0, 0, 0, 0.4)'
                                }}>
                                    <tr className="tblHdngOne">
                                        <th>S.no</th>
                                        <th>UDISE ID</th>
                                        <th>School Name</th>
                                        <th>District</th>
                                        <th>EduBlockName/Ward No.</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {eventsData.length > 0 ? (
                                        eventsData.map((item, i) => (
                                            <tr key={item._id || i}>
                                                <td>{(currentPage - 1) * 10 + i + 1}</td>
                                                <td>{item.udise_id || item.school_data?.udiseCode || 'N/A'}</td>
                                                <td>{item.school_data?.schooName || 'N/A'}</td>
                                                <td>{item.school_data?.eduDistrictName || 'N/A'}</td>
                                                <td>{item.school_data?.eduBlockName || 'N/A'}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr><td colSpan={5} className="text-center">Data not Found.</td></tr>
                                    )}
                                </tbody>
                            </table>
                        ) : null}
                    </div>
                    {!loading && totalPages > 1 && (
                        <div className="mb-3 text-center">
                            <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
                            <span style={{ margin: '0 10px' }}>Page {currentPage} of {totalPages}</span>
                            <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Next</button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default AdminViewTabletrees;
